// extracted by mini-css-extract-plugin
module.exports = {"digital-chip":"digital-chip_digital-chip__smJYK"};